import {
  Button,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  Textarea,
  VStack,
  FormErrorMessage,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ChatState } from "../../Context/ChatProvider";

const VendorSignup = () => {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phone, setPhone] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [categories, setCategories] = useState([]);
  const [location, setLocation] = useState("");
  const [pic, setPic] = useState();
  const [description, setDescription] = useState("");

  const [availableCategories, setAvailableCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const toast = useToast();
  const navigate = useNavigate();
  const { setUser } = ChatState();

  const handleClick = () => setShow(!show);

  // Fetch categories from API on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoadingCategories(true);
        const { data } = await axios.get("/api/category?active=true");
        setAvailableCategories(data);
        setLoadingCategories(false);
      } catch (error) {
        toast({
          title: "Error loading categories",
          description: "Failed to load service categories",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, [toast]);

  const postDetails = (pics) => {
    setLoading(true);
    if (pics === undefined) {
      toast({
        title: "Please select an image",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }

    if (
      pics.type === "image/jpeg" ||
      pics.type === "image/png" ||
      pics.type === "image/jpg"
    ) {
      const data = new FormData();
      data.append("file", pics);
      data.append("upload_preset", "ATO-cloudinary");
      data.append("cloud_name", "dlmrbvuln");
      fetch("https://api.cloudinary.com/v1_1/dlmrbvuln/image/upload", {
        method: "post",
        body: data,
      })
        .then((res) => res.json())
        .then((data) => {
          setPic(data.url.toString());
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      toast({
        title: "Please select an image",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }
  };

  const submitHandler = async () => {
    setLoading(true);
    setPasswordError("");

    if (
      !name ||
      !email ||
      !companyName ||
      !phone ||
      !businessRegistrationNumber ||
      !password ||
      !confirmpassword ||
      !location
    ) {
      toast({
        title: "Please fill all required fields",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }

    if (password !== confirmpassword) {
      setPasswordError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/api/user",
        {
          name,
          email,
          password,
          role: "vendor",
          pic,
          companyName,
          phone,
          businessRegistrationNumber,
          categories,
          description,
          location,
        },
        config
      );

      toast({
        title: "Registration Successful!",
        description:
          data.message ||
          "Please check your email to verify your account before logging in.",
        status: "success",
        duration: 10000,
        isClosable: true,
        position: "bottom",
      });

      setLoading(false);
      // Don't navigate or store token - user needs to verify email first
    } catch (error) {
      toast({
        title: "Error Occurred!",
        description: error.response?.data?.message || error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
  };

  return (
    <VStack spacing="5px" color="black">
      <FormControl id="name" isRequired>
        <FormLabel>Your Name:</FormLabel>
        <Input
          placeholder="Enter Your Name"
          onChange={(e) => setName(e.target.value)}
        />
      </FormControl>

      <FormControl id="company-name" isRequired>
        <FormLabel>Company Name:</FormLabel>
        <Input
          placeholder="Enter Your Company Name"
          onChange={(e) => setCompanyName(e.target.value)}
        />
      </FormControl>

      <FormControl id="email" isRequired>
        <FormLabel>Email:</FormLabel>
        <Input
          placeholder="Enter Your Email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>

      <FormControl id="phone" isRequired>
        <FormLabel>Phone Number:</FormLabel>
        <Input
          placeholder="Enter Your Phone Number"
          onChange={(e) => setPhone(e.target.value)}
        />
      </FormControl>

      <FormControl id="business-registration-number" isRequired>
        <FormLabel>Business Registration Number:</FormLabel>
        <Input
          placeholder="Enter Your Business Registration Number"
          onChange={(e) => setBusinessRegistrationNumber(e.target.value)}
        />
      </FormControl>

      <FormControl id="password" isRequired>
        <FormLabel>Password:</FormLabel>
        <InputGroup>
          <Input
            type={show ? "text" : "password"}
            placeholder="Enter Your Password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>

      <FormControl id="confirm-password" isRequired isInvalid={passwordError}>
        <FormLabel>Confirm Password:</FormLabel>
        <InputGroup>
          <Input
            type={show ? "text" : "password"}
            placeholder="Confirm Password"
            onChange={(e) => {
              setConfirmpassword(e.target.value);
              setPasswordError("");
            }}
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
        {passwordError && <FormErrorMessage>{passwordError}</FormErrorMessage>}
      </FormControl>

      {/* Categories Checkbox */}
      <FormControl id="categories">
        <FormLabel>Service Categories:</FormLabel>
        {loadingCategories ? (
          <Text>Loading categories...</Text>
        ) : (
          <CheckboxGroup
            colorScheme="blue"
            onChange={(selectedCategories) => setCategories(selectedCategories)}
          >
            <Stack direction="column">
              {availableCategories.map((category) => (
                <Checkbox key={category._id} value={category.name}>
                  {category.name}
                </Checkbox>
              ))}
            </Stack>
          </CheckboxGroup>
        )}
      </FormControl>

      {/* Location Field */}
      <FormControl id="location" isRequired>
        <FormLabel>Location:</FormLabel>
        <Input
          placeholder="Enter Your Business Location (e.g., Los Angeles, CA)"
          onChange={(e) => setLocation(e.target.value)}
        />
      </FormControl>

      <FormControl id="pic">
        <FormLabel>Upload Your Picture</FormLabel>
        <Input
          type="file"
          p={1.5}
          accept="image/*"
          onChange={(e) => postDetails(e.target.files[0])}
        />
      </FormControl>

      {/* Description Field */}
      <FormControl id="description" isRequired>
        <FormLabel>Description:</FormLabel>
        <Textarea
          placeholder="Enter a brief description about your business"
          onChange={(e) => setDescription(e.target.value)}
        />
      </FormControl>

      <Button
        colorScheme="orange"
        width="100%"
        style={{ marginTop: 15 }}
        onClick={submitHandler}
        isLoading={loading}
      >
        Register
      </Button>
    </VStack>
  );
};

export default VendorSignup;
